import axios from 'axios';
import AppSettings from '../appsettings';

const BASE_URL = `${AppSettings.API_BASE_URL}/webanalytics`;

const webAnalyticsService = {
    // ✅ Get all analytics entries
    getAll: async () => {
        const response = await axios.get(`${BASE_URL}`);
        return response.data;
    },

    getAllByPublisher: async (publisherId) => {
        const response = await axios.get(`${BASE_URL}/GetAllByPublisher`, {
            params: { publisherId }
        });
        return response.data;
    },

    // ✅ Get single entry by ID
    getById: async (id) => {
        const response = await axios.get(`${BASE_URL}/${id}`);
        return response.data;
    },

    // ✅ Create a new analytics entry
    create: async (analyticsData) => {
        const response = await axios.post(`${BASE_URL}`, analyticsData); // ✅ plain object
        return response.data;
    },

    // ✅ Update an analytics entry
    update: async (id, analyticsData) => {
        const response = await axios.put(`${BASE_URL}/${id}`, analyticsData); // ✅ plain object
        return response.status === 204;
    },


    // ✅ Delete an analytics entry
    delete: async (id) => {
        const response = await axios.delete(`${BASE_URL}/${id}`);
        return response.status === 204;
    },
};

export default webAnalyticsService;
